/** 用户表单 */
<template>
  <el-dialog
    :visible.sync="showDialog"
    :title="title"
    :lock-scroll="false"
    :close-on-click-modal="false"
    :width="width"
    center
    :before-close="handleClose"
    @close="emitInput(false)"
    class="flex-center"
  >
    <slot></slot>
  </el-dialog>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: "40%"
    }
  },
  data() {
    return {};
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(val) {
        return val;
      }
    }
  },

  methods: {
    emitInput(val) {
      this.$emit("input", val);
    },
    handleClose(done) {
      this.$emit("handleClose");
      done();
    }
  }
};
</script>
<style lang="less" scoped>
::v-deep .el-dialog {
  border-radius: 18px;
  margin: 0 auto !important;
  overflow: hidden;

  .el-dialog__header {
    height: 60px;
    line-height: 44px;
    background-color: #1b9cee;
    padding: 10px;
    box-sizing: border-box;
    .el-dialog__title {
      font-size: 18px;
      color: rgba(255, 255, 255, 1);
    }
  }
  .el-dialog__body {
    overflow-y: auto !important;
    overflow-x: auto !important;
    max-height: 80vh !important;
    border-bottom-right-radius: 18px;
    overflow: hidden;
    /* 整体滚动条 */
    &::-webkit-scrollbar {
      width: 10px;
    }

    /* 滚动条轨道 */
    &::-webkit-scrollbar-track {
      background-color: #ffffff;
      border-radius: 6px;
    }

    /* 滚动条滑块 */
    &::-webkit-scrollbar-thumb {
      background-color: #888;
      border-radius: 6px;
      border: 1px solid #f1f1f1;
      &:hover {
        background-color: #555;
      }
    }
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
  }
}
</style>
